export default __webpack_public_path__ + "static/englet-5-4aa232bb816447e7c2ab47d9da7cbf93.jpg";